import { FC, SVGProps } from 'react';

export const MinusIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M26.8774 14.75H5.25C4.55964 14.75 4 15.3096 4 16C4 16.6904 4.55964 17.25 5.25 17.25L26.8774 17.25C27.5678 17.25 28.1274 16.6904 28.1274 16C28.1274 15.3096 27.5678 14.75 26.8774 14.75Z"
			fill="currentColor"
		/>
	</svg>
);
